import { render, staticRenderFns } from "./CampaignsList.vue?vue&type=template&id=1913ff64&scoped=true"
import script from "./CampaignsList.vue?vue&type=script&lang=js"
export * from "./CampaignsList.vue?vue&type=script&lang=js"
import style0 from "./CampaignsList.vue?vue&type=style&index=0&id=1913ff64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1913ff64",
  null
  
)

export default component.exports